module.exports = __webpack_public_path__ + "img/blank-pro.46ed037d.png";